<mat-nav-list class="sd_bar" [ngClass]="{
    'disabledSidebar': subscriptionStatusConst.includes(subscriptionStatus)
  }">
  <button class="closeSidebar" (click)="toggleSidenav()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="logo-brand">
    <figure class="logo">
      <!-- <img src="{{assetsConst.logoColored}}" alt="logo" /> -->
        <img [src]="adminLogo ?? assetsConst.logoColored" alt="logo" />
    </figure>
    <figure class="logo1">
      <!-- <img src="{{assetsConst.logoSmall}}" alt="logo" /> -->
      <img [src]="adminLogo ?? assetsConst.logoSmall" alt="logo" />
    </figure>
    <div class="toggle" (click)="toggleSidenavWeb()">
      <span></span>
      <span></span>
      <span></span>
    </div>

  </div>

  @for (item of sideBar; track $index) {
    <div>
      @if (!item.isSubMenu) {
        @if (item.isView) {
          <mat-list-item
            (click)="onItemClick(item)"
            [routerLink]="subscriptionStatusConst.includes(subscriptionStatus) ? null:item.path"
            routerLinkActive="active"

            (click)="toggleSidenav()">
            <figure class="sd_cn">
              <img src="{{ item.img }}" alt="" />
            </figure>
            <div class="sidenav-item">
              <h5 class="lead">{{ item.label | translate }}</h5>
            </div>
          </mat-list-item>
        }
      }
      @if (item.isSubMenu) {
        @if (item.isView) {
          <mat-accordion>
            <mat-expansion-panel class="drop_lst_nv">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-list-item

                    (click)="toggleSidenav()">
                    <figure class="sd_cn" mat-raised-button>
                      <img src="{{ item.img }}" alt="" />
                    </figure>
                    <div class="sidenav-item">
                      <h5 class="lead">{{ item.label | translate }}</h5>
                    </div>
                  </mat-list-item>
                </mat-panel-title>
              </mat-expansion-panel-header>

              @if (item.subMenuItems?.length) {
                @for (sub of item.subMenuItems; track $index) {
                  @if (sub.isView) {
                    <mat-list-item
                      [routerLink]="subscriptionStatusConst.includes(subscriptionStatus) ? null:sub.path"

                      routerLinkActive="active"
                      (click)="toggleSidenav()">
                      <figure class="sd_cn">
                        <img src="{{ sub.img }}" alt="images" />
                      </figure>
                      <div class="sidenav-item">
                        <h5 class="lead">{{ sub.label | translate }}</h5>
                      </div>
                    </mat-list-item>
                  }
                }
              }
            </mat-expansion-panel>
          </mat-accordion>
        }
      }
    </div>
  }
</mat-nav-list>
